import { FaPencilAlt } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import MenuItem from "@mui/material/MenuItem";
import { useContext, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { MyContext } from "../../App";
import { Link } from "react-router-dom";
import { deleteData, fetchDataFromApi } from "../../utils/api";

const Dashboard = () => {
  const [categoryVal, setcategoryVal] = useState("All");
  const [productList, setProductList] = useState([]);

  // 🔥 delete dialog states
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const context = useContext(MyContext);

  // ================= Fetch products =================
  useEffect(() => {
    window.scrollTo(0, 0);

    context.setProgress(40);

    fetchDataFromApi(`/api/products`).then((res) => {
      setProductList(res);
      context.setProgress(100);
    });
  }, []);

  useEffect(() => {
    context.setisHideSidebarAndHeader(false);
    setProductList(context.productList);
  }, [context.productList]);

  // ================= Open delete dialog =================
  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setOpenDelete(true);
  };

  // ================= Confirm delete =================
  const confirmDelete = () => {
    context.setProgress(40);

    deleteData(`/api/products/${selectedId}`).then(() => {
      context.setProgress(100);

      context.setAlertBox({
        open: true,
        error: true,
        msg: "Product Deleted!",
      });

      fetchDataFromApi("/api/products").then((res) => {
        setProductList(res);
      });

      setOpenDelete(false);
    });
  };

  // ================= Filter =================
  const handleChangeCategory = (event) => {
    context.setProgress(40);

    const selectedValue = event.target.value;
    setcategoryVal(selectedValue);

    if (selectedValue !== "All") {
      fetchDataFromApi(`/api/products/category?category=${selectedValue}`).then(
        (res) => {
          setProductList(res);
          context.setProgress(100);
        }
      );
    } else {
      fetchDataFromApi("/api/products").then((res) => {
        setProductList(res);
        context.setProgress(100);
      });
    }
  };

  return (
    <>
      <div className="right-content w-100">
        <div className="card shadow border-0 p-3 mt-4">
          <h3 className="hd">Best Selling Products</h3>

          {/* ================= Filters ================= */}
          <div className="row cardFilters mt-3">
            <div className="col-md-3">
              <h4>CATEGORY BY</h4>

              <FormControl className="w-100" size="small">
                <Select
                  value={categoryVal}
                  onChange={handleChangeCategory}
                  displayEmpty
                  className="w-100"
                >
                  <MenuItem value="All">
                    <em>All</em>
                  </MenuItem>

                  {context.catData?.categoryList?.map((cat, index) => (
                    <MenuItem
                      className="text-capitalize"
                      value={cat._id}
                      key={index}
                    >
                      {cat.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>

          {/* ================= Table ================= */}
          <div className="table-responsive mt-3 product-table-scroll">
            <table className="table table-bordered v-align">
              <thead className="thead-dark">
                <tr>
                  <th style={{ width: "300px" }}>PRODUCT</th>
                  <th>CATEGORY</th>
                  <th>VARIANT GROUP</th>
                  <th>LEG FINISH</th>
                  <th>LEG MATERIAL</th>
                  <th>TOP FINISH</th>
                  <th>TOP MATERIAL</th>
                  <th>FINISH</th>
                  <th>MATERIAL</th>
                  <th>CBM</th>
                  <th>CODE</th>
                  <th>HEIGHT</th>
                  <th>WIDTH</th>
                  <th>LENGTH</th>
                  <th>ACTION</th>
                </tr>
              </thead>

              <tbody>
                {productList?.products?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex align-items-center productBox">
                        <div className="imgWrapper">
                          <div className="img card shadow m-0">
                            <img
                              src={`${context.baseUrl}/uploads/${item?.images?.[0]}`}
                              className="w-100"
                              alt=""
                            />
                          </div>
                        </div>

                        <div className="info pl-3">
                          <h6>{item?.name}</h6>
                        </div>
                      </div>
                    </td>

                    <td>{item?.category?.name}</td>
                    <td>{item?.variantGroup?.name}</td>
                    <td>{item?.legfinish?.name}</td>
                    <td>{item?.legmaterial?.name}</td>
                    <td>{item?.topfinish?.name}</td>
                    <td>{item?.topmaterial?.name}</td>
                    <td>{item?.finish?.name}</td>
                    <td>{item?.material?.name}</td>
                    <td>{item?.cbm}</td>
                    <td>{item?.code}</td>
                    <td>{item?.height}</td>
                    <td>{item?.width}</td>
                    <td>{item?.length}</td>

                    <td>
                      <div className="actions d-flex align-items-center">
                        <Link to={`/product/edit/${item._id}`}>
                          <Button className="success" color="success">
                            <FaPencilAlt />
                          </Button>
                        </Link>

                        <Button
                          className="error"
                          color="error"
                          onClick={() => handleDeleteClick(item._id)}
                        >
                          <MdDelete />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ================= Delete Confirmation Dialog ================= */}
      <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
        <DialogTitle>Delete Product</DialogTitle>

        <DialogContent>
          Are you sure you want to delete this product?
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDelete(false)}>Cancel</Button>

          <Button
            color="error"
            variant="contained"
            startIcon={<MdDelete />}
            onClick={confirmDelete}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Dashboard;

